import { z } from "zod";

export const MetadataEnvOffChain = z.object({
  artist: z.object({ displayName: z.string().nullish() }).nullish(),
  collection: z.object({ title: z.string().nullish() }).nullish(),
});

export type MetadataEnvOffChain = z.infer<typeof MetadataEnvOffChain>;

export const MetadataEnvOnChain = z.object({
  datumArtwork: z.object({ numEditions: z.number().nullish() }).nullish(),
});

export type MetadataEnvOnChain = z.infer<typeof MetadataEnvOnChain>;

export const MetadataEnv = z.intersection(
  MetadataEnvOffChain,
  MetadataEnvOnChain
);

export type MetadataEnv = z.infer<typeof MetadataEnv>;
